var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRatingscale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ratin-scale",
    transform: "translate(-765 -303)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_273",
    "data-name": "Ellipse 273",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(765 303)",
    fill: "#004b75",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422",
    transform: "translate(-148 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421",
    transform: "translate(933 314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1420",
    "data-name": "Group 1420",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M7.419,41a.575.575,0,0,1,0-1.107H36.545a.575.575,0,0,1,0,1.107Zm0,5.474a.575.575,0,0,1,0-1.107H21.5a.575.575,0,0,1,0,1.107Zm0-10.948a.575.575,0,0,1,0-1.107H36.545a.575.575,0,0,1,0,1.107Zm0-5.474a.575.575,0,0,1,0-1.107H36.545a.575.575,0,0,1,0,1.107Zm0-5.474a.575.575,0,0,1,0-1.107H36.545a.575.575,0,0,1,0,1.107Zm0-5.474a.575.575,0,0,1,0-1.107H36.545a.575.575,0,0,1,0,1.107Z",
    transform: "translate(-7 -18)",
    fill: "#004c75",
    stroke: "#004c75",
    strokeWidth: 0.3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingscale);
export default __webpack_public_path__ + "static/media/Ratingscale.0d40a251a160039f03e8f41fdcc29e7e.svg";
export { ForwardRef as ReactComponent };